import {

  Box,

  FormControl,

  Grid,

  InputLabel,

  MenuItem,

  Select,

  TextField,

  Typography,

} from "@mui/material";

import { Field } from "formik";

import WDBox from "../../../../../MaterialComponents/WDBox";



import React, { useEffect } from "react";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";



import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";



import { MEDICAL_LOCATIONS } from "../../../../../Configurations/StatFieldData";

import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";

import TicketMultiCertificateField from "../../../../../Components/TicketMultiCertificateField";

import FileField from "../../../../Common/Ticket/NewTicket/panels/FileField";









const CustomerStatFieldInfo = (props) => {

  dayjs.extend(utc);

  // dayjs.extend(utc);

  // dayjs.extend(tz);

  // dayjs.tz.setDefault("Asia/Kolkata");



  const {

    staticFields,

    isUidready,

    formikRef,

    setFieldValue,

    uploadingDocs,

    onUpload,

    onUploadComplete,

    formikValues,

    employeeUid,

    onDocumentUploaded,

  } = props;

  useEffect(() => {
    if (staticFields.includes("medicalLocation") && !formikValues?.medicalLocation) {
      setFieldValue("medicalLocation", MEDICAL_LOCATIONS[0]);
    }
  }, [staticFields, formikValues?.medicalLocation, setFieldValue]);




  return (

    <WDBox my={2}>

      {staticFields.length ? (

        <Typography fontSize={10} color={isUidready ? "green" : "red"}>

          {isUidready 

            ? "** Fields are active. Fill in customer details and submit the form." 

            : "** Select an employee to make below fields active"}

        </Typography>

      ) : null}

      <Grid container spacing={1}>

        {staticFields.includes("firstNameEn") && (

          <Grid item xs={6} my={1}>

            <Field

              name="firstNameEn"

              label="First Name (English)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("middleNameEn") && (

          <Grid item xs={6} my={1}>

            <Field

              name="middleNameEn"

              label="Middle Name (English)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("lastNameEn") && (

          <Grid item xs={6} my={1}>

            <Field

              name="lastNameEn"

              label="Last Name (English)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("firstNameAr") && (

          <Grid item xs={6} my={1}>

            <Field

              name="firstNameAr"

              label="Fist Name (Arabic)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("middleNameAr") && (

          <Grid item xs={6} my={1}>

            <Field

              name="middleNameAr"

              label="Middile Name (Arabic)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("lastNameAr") && (

          <Grid item xs={6} my={1}>

            <Field

              name="lastNameAr"

              label="Last Name (Arabic)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("nameEn") && (

          <Grid item xs={6} my={1}>

            <Field

              name="nameEn"

              label="Name (English)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("nameAr") && (

          <Grid item xs={6} my={1}>

            <Field

              name="nameAr"

              label="Name (Arabic)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("dob") && (

          <Grid item xs={6} my={1}>

            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DemoContainer

                components={["DatePicker", "DatePicker"]}

                sx={{ position: "relative", top: -8 }}

              >

                <Field

                  name="dob"

                  as={DatePicker}

                  disabled={!isUidready}

                  format="DD-MM-YYYY"

                  label="Date Of Birth"

                  onChange={(newValue) => {

                    let formattedDate = dayjs.utc(newValue).local().format("YYYY-MM-DD");

                    setFieldValue("dob", dayjs.utc(formattedDate, "YYYY-MM-DD"));

                  }}

                  slotProps={{

                    textField: { fullWidth: true, size: "small" },

                  }}

                />

              </DemoContainer>

            </LocalizationProvider>

          </Grid>

        )}

        {staticFields.includes("gender") && (

          <Grid item xs={6} my={1}>

            <FormControl fullWidth>

              <InputLabel id="gender-select-label">Gender</InputLabel>

              <Field

                labelId="gender-select-label"

                name="gender"

                label="Gender"

                fullWidth

                size="small"

                as={Select}

                disabled={!isUidready}

              >

                <MenuItem value="MALE">MALE</MenuItem>

                <MenuItem value="FEMALE">FEMALE</MenuItem>

              </Field>

            </FormControl>

          </Grid>

        )}

        {staticFields.includes("nationality") && (

          <Grid item xs={6} my={1}>

            <Field

              name="nationality"

              label="Nationality"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("passportNumber") && (

          <Grid item xs={6} my={1}>

            <Field

              name="passportNumber"

              label="Passport Number"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("passportIssue") && (

          <Grid item xs={6} my={1}>

            <Field

              name="passportIssue"

              label="Passport Issue"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("passportExpiry") && (

          <Grid item xs={6} my={1}>

            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DemoContainer

                components={["DatePicker", "DatePicker"]}

                sx={{ position: "relative", top: -8 }}

              >

                <Field

                  name="passportExpiry"

                  as={DatePicker}

                  disabled={!isUidready}

                  format="DD-MM-YYYY"

                  label="Passport Expiry Date"

                  onChange={(newValue) => {

                    let formattedDate = dayjs.utc(newValue).local().format("YYYY-MM-DD");

                    setFieldValue("passportExpiry", dayjs.utc(formattedDate, "YYYY-MM-DD"));

                  }}

                  slotProps={{

                    textField: { fullWidth: true, size: "small" },

                  }}

                />

              </DemoContainer>

            </LocalizationProvider>

          </Grid>

        )}

        {staticFields.includes("passportIssuePlaceEn") && (

          <Grid item xs={6} my={1}>

            <Field

              name="passportIssuePlaceEn"

              label="Passport Issued Place (English)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("passportIssuePlaceAr") && (

          <Grid item xs={6} my={1}>

            <Field

              name="passportIssuePlaceAr"

              label="Passport Issued Place (Arabic)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("emiratesId") && (

          <Grid item xs={6} my={1}>

            <Field

              name="emiratesId"

              label="Emirated Id"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("emiratesIdIssueDate") && (

          <Grid item xs={6} my={1}>

            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DemoContainer

                components={["DatePicker", "DatePicker"]}

                sx={{ position: "relative", top: -8 }}

              >

                <Field

                  name="emiratesIdIssueDate"

                  as={DatePicker}

                  disabled={!isUidready}

                  format="DD-MM-YYYY"

                  label="Emirates Id Issue Date"

                  onChange={(newValue) => {

                    let formattedDate = dayjs.utc(newValue).local().format("YYYY-MM-DD");

                    setFieldValue("emiratesIdIssueDate", dayjs.utc(formattedDate, "YYYY-MM-DD"));

                  }}

                  slotProps={{

                    textField: { fullWidth: true, size: "small" },

                  }}

                />

              </DemoContainer>

            </LocalizationProvider>

          </Grid>

        )}

        {staticFields.includes("emiratesIdExpiryDate") && (

          <Grid item xs={6} my={1}>

            <LocalizationProvider dateAdapter={AdapterDayjs}>

              <DemoContainer

                components={["DatePicker", "DatePicker"]}

                sx={{ position: "relative", top: -8 }}

              >

                <Field

                  name="emiratesIdExpiryDate"

                  as={DatePicker}

                  disabled={!isUidready}

                  format="DD-MM-YYYY"

                  label="Emirates Id Expiry Date"

                  onChange={(newValue) => {

                    let formattedDate = dayjs.utc(newValue).local().format("YYYY-MM-DD");

                    setFieldValue("emiratesIdExpiryDate", dayjs.utc(formattedDate, "YYYY-MM-DD"));

                  }}

                  slotProps={{

                    textField: { fullWidth: true, size: "small" },

                  }}

                />

              </DemoContainer>

            </LocalizationProvider>

          </Grid>

        )}

        {staticFields.includes("birthPlaceEn") && (

          <Grid item xs={6} my={1}>

            <Field

              name="birthPlaceEn"

              label="Birth Place (English)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("birthPlaceAr") && (

          <Grid item xs={6} my={1}>

            <Field

              name="birthPlaceAr"

              label="Birth Place (Arabic)"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("birthCertificate") && (
          <Grid item xs={6} my={1}>
            <FileField
              field={{ name: "birthCertificate", value: formikValues?.birthCertificate, title: "Birth Certificate", type: "PDF" }}
              onFileUpload={(response) => setFieldValue("birthCertificate", response)}
              onFileRemove={() => setFieldValue("birthCertificate", null)}
              employeeUid={employeeUid}
              contextProps={{}}
              deferBulkUpload
              allowMultiple
            />
          </Grid>
        )}

        {staticFields.includes("emirate") && (

          <Grid item xs={6} my={1}>

            <Field

              name="emirate"

              label="Emirate"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("medicalLocation") && (

          <Grid item xs={6} my={1}>

            <FormControl fullWidth>

              <InputLabel id="medical-location-select-label">Medical Location</InputLabel>

              <Field

                labelId="medical-location-select-label"

                name="medicalLocation"

                label="Medical Location"

                fullWidth

                size="small"

                as={Select}

                disabled={!isUidready}

              >

                {MEDICAL_LOCATIONS.map((loc) => (

                  <MenuItem key={loc} value={loc}>{loc}</MenuItem>

                ))}

              </Field>

            </FormControl>

          </Grid>

        )}

        {staticFields.includes("address") && (

          <Grid item xs={6} my={1}>

            <Field

              name="address"

              label="Address"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("area") && (

          <Grid item xs={6} my={1}>

            <Field

              name="area"

              label="Area"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("buildingNumber") && (

          <Grid item xs={6} my={1}>

            <Field

              name="buildingNumber"

              label="Building Number"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("poBox") && (

          <Grid item xs={6} my={1}>

            <Field

              name="poBox"

              label="Po Box"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("mobileNumber") && (

          <Grid item xs={6} my={1}>

            <Field

              name="mobileNumber"

              label="Mobile Number"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("landNumber") && (

          <Grid item xs={6} my={1}>

            <Field

              name="landNumber"

              label="Land Number"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("deliveryNumber") && (

          <Grid item xs={6} my={1}>

            <Field

              name="deliveryNumber"

              label="Delivery Number"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("email") && (

          <Grid item xs={6} my={1}>

            <Field

              name="email"

              label="Email"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("fileNumber") && (

          <Grid item xs={6} my={1}>

            <Field

              name="fileNumber"

              label="File Number"

              fullWidth

              as={TextField}

              size="small"

              disabled={!isUidready}

            />

          </Grid>

        )}

        {staticFields.includes("passportCopy") && (
          <Grid item xs={6} my={1}>
            <FileField
              field={{ name: "passportCopy", value: formikValues?.passportCopy, title: "Passport Copy", type: "PDF" }}
              onFileUpload={(response) => setFieldValue("passportCopy", response)}
              onFileRemove={() => setFieldValue("passportCopy", null)}
              employeeUid={employeeUid}
              contextProps={{}}
              deferBulkUpload
              allowMultiple
            />
          </Grid>
        )}

        {staticFields.includes("visaPage") && (
          <Grid item xs={6} my={1}>
            <FileField
              field={{ name: "visaPage", value: formikValues?.visaPage, title: "Visa Page", type: "PDF" }}
              onFileUpload={(response) => setFieldValue("visaPage", response)}
              onFileRemove={() => setFieldValue("visaPage", null)}
              employeeUid={employeeUid}
              contextProps={{}}
              deferBulkUpload
              allowMultiple
            />
          </Grid>
        )}

        {staticFields.includes("photo") && (
          <Grid item xs={6} my={1}>
            <FileField
              field={{ name: "photo", value: formikValues?.photo, title: "Photo", type: "IMAGE" }}
              onFileUpload={(response) => setFieldValue("photo", response)}
              onFileRemove={() => setFieldValue("photo", null)}
              employeeUid={employeeUid}
              contextProps={{}}
              deferBulkUpload
              allowMultiple
            />
          </Grid>
        )}

        {staticFields.includes("shinasnama") && (
          <Grid item xs={6} my={1}>
            <FileField
              field={{ name: "shinasnama", value: formikValues?.shinasnama, title: "Shinasnama", type: "PDF" }}
              onFileUpload={(response) => setFieldValue("shinasnama", response)}
              onFileRemove={() => setFieldValue("shinasnama", null)}
              employeeUid={employeeUid}
              contextProps={{}}
              deferBulkUpload
              allowMultiple
            />
          </Grid>
        )}

        {staticFields.includes("labourContract") && (
          <Grid item xs={6} my={1}>
            <FileField
              field={{ name: "labourContract", value: formikValues?.labourContract, title: "Labour Contract", type: "PDF" }}
              onFileUpload={(response) => setFieldValue("labourContract", response)}
              onFileRemove={() => setFieldValue("labourContract", null)}
              employeeUid={employeeUid}
              contextProps={{}}
              deferBulkUpload
              allowMultiple
            />
          </Grid>
        )}

        {staticFields.includes("salaryCertificate") && (
          <Grid item xs={6} my={1}>
            <FileField
              field={{ name: "salaryCertificate", value: formikValues?.salaryCertificate, title: "Salary Certificate", type: "PDF" }}
              onFileUpload={(response) => setFieldValue("salaryCertificate", response)}
              onFileRemove={() => setFieldValue("salaryCertificate", null)}
              employeeUid={employeeUid}
              contextProps={{}}
              deferBulkUpload
              allowMultiple
            />
          </Grid>
        )}

        {staticFields.includes("resume") && (
          <Grid item xs={6} my={1}>
            <FileField
              field={{ name: "resume", value: formikValues?.resume, title: "Resume / CV", type: "DOCUMENT" }}
              onFileUpload={(response) => setFieldValue("resume", response)}
              onFileRemove={() => setFieldValue("resume", null)}
              employeeUid={employeeUid}
              contextProps={{}}
              deferBulkUpload
              allowMultiple
            />
          </Grid>
        )}

        {staticFields.includes("policeClearanceCertificate") && (
          <Grid item xs={6} my={1}>
            <FileField
              field={{ name: "policeClearanceCertificate", value: formikValues?.policeClearanceCertificate, title: "Police Clearance Certificate", type: "PDF" }}
              onFileUpload={(response) => setFieldValue("policeClearanceCertificate", response)}
              onFileRemove={() => setFieldValue("policeClearanceCertificate", null)}
              employeeUid={employeeUid}
              contextProps={{}}
              deferBulkUpload
              allowMultiple
            />
          </Grid>
        )}

        {staticFields.includes("educationalCertificate") && (
          <Grid item xs={6} my={1}>
            <TicketMultiCertificateField
              field={{ name: "educationalCertificate", title: "Educational Certificate" }}
              value={formikValues?.educationalCertificate}
              onChange={(v) => setFieldValue("educationalCertificate", v)}
              employeeUid={employeeUid}
              disabled={!isUidready}
            />
          </Grid>
        )}

        {staticFields.includes("experienceCertificate") && (
          <Grid item xs={6} my={1}>
            <TicketMultiCertificateField
              field={{ name: "experienceCertificate", title: "Experience Certificate" }}
              value={formikValues?.experienceCertificate}
              onChange={(v) => setFieldValue("experienceCertificate", v)}
              employeeUid={employeeUid}
              disabled={!isUidready}
            />
          </Grid>
        )}

      </Grid>

    </WDBox>

  );

};



export default CustomerStatFieldInfo;

